import { render, staticRenderFns } from "./temporary-solution.vue?vue&type=template&id=17492810"
import script from "./temporary-solution.vue?vue&type=script&lang=js"
export * from "./temporary-solution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports